import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M20 16H4V4h10.1c-.08-.39-.18-1.11 0-2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V6.98c-.58.44-1.26.77-2 .92V16z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "19",
  cy: "3",
  r: "3"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M6 12h8v2H6zm0-3h12v2H6zm0-1h12v-.1c-1.21-.25-2.25-.95-2.97-1.9H6v2z"
}, "2")], 'MarkUnreadChatAltOutlined');